// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab___33bxV","tab__name":"tab__name___3y2dF"};